<template>
    <div>
        <table-title>筛选栏</table-title>
        <Form :model="queryParams" inline :label-width="90">
            <FormItem label="租借人">
                <leasee-select roleType="LEASEE" v-model="queryParams.leaseeId" />
            </FormItem>
            <FormItem label="标的物小类">
                <target-type-select @onTargetType="onTargetType" />
            </FormItem>
            <br />
            <FormItem label="创建时间">
                <DatePicker type="daterange" split-panels placeholder="请选择" :editable="false" @on-change="onCreateTime" style="width:200px"></DatePicker>
            </FormItem>
            <FormItem label="计费截止日">
                <DatePicker type="daterange" split-panels placeholder="请选择" :editable="false" @on-change="onBillingUntilTime" style="width:200px"></DatePicker>
            </FormItem>
            <Button type="primary" style="margin-left:20px" @click="search">查询</Button>
        </Form>
        <table-title>报损列表</table-title>
        <data-grid ref="lg" :columns="cols" :queryParams="queryParams" paramsName="param" :queryUrl="queryUrl"  subListName :dataList="[]">
            <template #default="{columns, data}">
            </template>
        </data-grid>
    
    </div>
</template>

<script>
import tableTitle from 'components/tableTitle/tableTitle.vue'
import dataGrid from '@/components/datagrid.vue'
import dictSelect from '@/components/select/dict-select.vue'
import leaseeSelect from '@/components/select/payee-select.vue'
import targetTypeSelect from '@/components/select/targetTypeSelect'


export default {
    name: 'breakageMangaeList',
    components: {
        tableTitle,
        dataGrid,
        dictSelect,
        targetTypeSelect,
        leaseeSelect,
    },
    data() {
        return {
            queryUrl: 'MID-OPERATE-LEASE/messageService/recycleService/queryBreakReports',
            queryParams: {
                leaseeId: "",
                targetType: "",
                createDateBegin: "",
                createDateEnd: "",
                billingUntilDateBegin: '',
                billingUntilDateEnd: '',
                pageNum: "",
                pageSize: ""
            },
            cols: [
                { title: '租借人', key: 'leaseeId', dict: ['bizObjects', 'member', true] },
                { title: '标的物小类', key: 'targetType', dict: ['target', 'type', true], },
                { title: '报损数量', key: 'breakAmount' },
                { title: '已回收数量', key: 'recycledAmount' },
                { title: '创建时间', key: 'createTime', formatter: 'datetime' },
                { title: '计费截止日', key: 'billingUntil', formatter: 'date' },
                // { title: '操作', slot: 'operation', width: 200 },
            ]
        }
    },
    methods: {
        // 创建时间
        onCreateTime(val) {
            this.queryParams.createDateBegin = val[0]
            this.queryParams.createDateEnd = val[1]
        },
        // 计费截止日
        onBillingUntilTime(val) {
            this.queryParams.billingUntilDateBegin = val[0]
            this.queryParams.billingUntilDateEnd = val[1]
        },
        onTargetType(val) {
            this.queryParams.targetType = val
         },
        search() {
            this.$refs['lg'].loadFirstPage()
        }
    }
}
</script>